import { type FunctionComponent } from 'react';

import { HorizontalContainer } from '@american-autonomy/ag-ui';

import DropdownText from 'components/text/DropdownText';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const SelectItem: FunctionComponent<Props> = ({
    children,
    className = '',
    isSelected,
    item,
    onClick,
    testId = TEST_ID
}) => {
    const selectedTextStyles = isSelected ? styles.selectedText : '';

    return (
        <HorizontalContainer
            className={`${styles.selectItem} ${className}`}
            onClick={onClick}
            testId={testId}>
            {children}

            <DropdownText className={selectedTextStyles} text={item.label} />
        </HorizontalContainer>
    );
};

export default SelectItem;
